var _ellipse, _ellipse2, _path, _path2, _path3, _ellipse3, _path4, _path5, _ellipse4, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandaAnony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 76,
    viewBox: "0 0 92 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.1018,
    cy: 14.8945,
    rx: 13.3148,
    ry: 14.8945,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7423,
    cy: 14.8945,
    rx: 13.3148,
    ry: 14.8945,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69864 28.817L8.70164 28.8105L8.70459 28.8039C12.9345 19.3967 17.7356 14.1064 25.3527 9.12076C31.1571 5.32168 38.5294 3.58418 45.8364 3.69243C53.1489 3.80076 60.2089 5.75503 65.3635 9.12089C71.5511 13.1753 77.1499 19.6073 80.6125 28.6958L80.6136 28.6986C83.9876 37.5144 84.613 46.4328 83.1194 53.554C81.614 60.7316 78.0692 65.697 73.457 67.3993C62.0383 71.3761 53.2556 73.3876 44.4962 73.428C35.741 73.4684 26.8553 71.5398 15.2384 67.403C13.3607 66.7002 11.5119 65.0601 9.90281 62.5205C8.30046 59.9915 7.02276 56.7008 6.24306 52.9636C4.68046 45.4739 5.17911 36.496 8.69864 28.817Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5299 28.7581C18.2724 28.7581 8.10868 40.339 9.59116 48.4885C11.0736 56.638 31.4001 58.3536 35.6344 49.1318C39.8688 39.9101 34.7873 28.7581 26.5299 28.7581Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1707 37.0684C71.4282 37.0684 81.2676 40.3389 79.7851 48.4884C78.3026 56.6379 57.9762 58.3536 53.7418 49.1318C49.5075 39.91 54.9133 37.0684 63.1707 37.0684Z",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0128,
    cy: 45.7002,
    rx: 9.31629,
    ry: 9.43625,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0593 45.4858C36.0593 49.6314 32.7414 52.992 28.6486 52.992C27.6592 52.992 26.7151 52.7956 25.8522 52.4392C26.3769 52.2081 26.7439 51.6783 26.7439 51.0618C26.7439 50.2327 26.0803 49.5606 25.2617 49.5606C24.4432 49.5606 23.7796 50.2327 23.7796 51.0618C23.7796 51.0903 23.7804 51.1186 23.7819 51.1467C22.2231 49.7706 21.2379 47.7448 21.2379 45.4858C21.2379 41.3403 24.5558 37.9797 28.6486 37.9797C29.5704 37.9797 30.4528 38.1502 31.2669 38.4617C29.8966 38.7261 28.8607 39.946 28.8607 41.411C28.8607 43.0692 30.1878 44.4134 31.825 44.4134C33.4621 44.4134 34.7892 43.0692 34.7892 41.411C34.7892 41.3665 34.7883 41.3223 34.7864 41.2782C35.5899 42.4784 36.0593 43.9266 36.0593 45.4858Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3778 50.5509C37.7974 50.7766 37.5721 51.6793 38.475 52.8077C40.5059 55.3459 42.9883 56.6442 44.568 56.6442C46.1478 56.6442 48.3499 55.6988 50.6613 52.8077C51.5634 51.6793 51.1121 50.7766 49.7586 50.551C48.4051 50.3253 40.9581 50.3253 39.3778 50.5509Z",
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.86,
    cy: 52.3564,
    rx: 1.8054,
    ry: 0.902698,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6022 48.4406C41.1258 47.4862 42.8933 46.9402 44.7781 46.9402C46.3371 46.9402 47.8158 47.3137 49.1426 47.9829C47.8778 46.4814 46.2845 45.5862 44.5531 45.5862C42.6525 45.5862 40.9181 46.665 39.6022 48.4406Z",
    fill: "#C2CFD1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6285 9.64139C13.6258 9.83745 13.72 10.0225 13.8798 10.1364L16.1162 11.6812C16.3056 11.8123 16.4007 12.042 16.3596 12.2689C16.3247 12.4965 16.1618 12.6833 15.9416 12.7503L13.3528 13.5704C13.2621 13.5983 13.1795 13.6473 13.1105 13.7128L13.0065 13.8172C12.9759 13.8587 12.9521 13.9057 12.9376 13.9557L12.1324 16.5526C12.0908 16.6792 12.0107 16.7897 11.9024 16.8684C11.6322 17.0535 11.2634 16.9893 11.0714 16.7237L9.51741 14.4935C9.40174 14.333 9.21548 14.2389 9.0179 14.2408L6.28437 14.2893C6.05565 14.2932 5.84586 14.1649 5.74586 13.9594C5.64471 13.7559 5.66457 13.5133 5.79796 13.3293L7.42671 11.1381C7.55669 10.9775 7.59544 10.7613 7.52967 10.5654L6.64005 7.99938C6.62147 7.94099 6.61173 7.87989 6.61276 7.81876L6.62031 7.75724C6.61831 7.71919 6.62246 7.68189 6.63199 7.64535L6.6584 7.58801L6.69664 7.49567L6.85814 7.33348C7.0174 7.2036 7.23105 7.16239 7.42685 7.22464L10.0001 8.0845C10.1874 8.1483 10.3942 8.11557 10.5531 7.99837L12.7373 6.36032C12.9216 6.22153 13.1679 6.19756 13.3754 6.29745C13.5801 6.40081 13.7062 6.61313 13.6994 6.84264L13.6285 9.64139Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8418 45.8202C56.8418 46.8629 60.1339 49.5503 64.9961 49.5503C69.8583 49.5503 74.225 47.3842 74.225 45.8202C74.225 44.2561 71.9576 47.624 64.9961 47.624C58.7313 47.624 56.8418 43.7348 56.8418 45.8202Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4941 56.0548V60.7156",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4171 57.9505C46.2621 62.8352 43.0222 62.7093 37.8555 57.9505",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandaAnony);
export default __webpack_public_path__ + "static/media/panda-anony.d50331f3b7215b5838941f0aba56ac3d.svg";
export { ForwardRef as ReactComponent };